<template>
  <div class="field-item field-item--top">
    <div class="field-label">
      {{ field.label }}<i v-if="field.fill_status" class="impor">*</i>
    </div>
    <div class="field-control">
      <div class="dyn-filelist">
        <label class="dyn-filelist-btn" :for="uid + '_input'">
          {{ field.prompt || '選擇文件' }}
          <span class="dyn-filelist-count">（最多{{ maxCount }}個）</span>
        </label>
        <input
          :id="uid + '_input'"
          type="file"
          multiple
          style="display:none"
          @change="onFileChange"
        />
        <ul class="dyn-filelist-preview">
          <li v-for="(item, i) in fileList" :key="i">
            <span class="dyn-filelist-name">{{ item.name }}</span>
            <span :class="['dyn-filelist-status', item.status]">{{ statusText(item.status) }}</span>
            <span v-if="item.status === 'error'" class="dyn-filelist-retry" @click="retryUpload(i)">重試</span>
            <span class="dyn-filelist-remove" @click="removeFile(i)">刪除</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { uploadSignFile } from '@/api/activity'

export default {
  name: 'FieldFileList',
  props: { field: Object, value: { default: () => [] } },
  data () { return { fileList: [] } },
  computed: {
    maxCount () { return this.field.maxlength || 9 },
    uid () { return `filelist_${this.field.value}` }
  },
  methods: {
    statusText (s) {
      return { uploading: '上傳中…', done: '✓', error: '上傳失敗' }[s] || ''
    },
    async onFileChange (e) {
      const files = Array.from(e.target.files || [])
      e.target.value = ''
      for (const f of files) {
        if (this.fileList.length >= this.maxCount) {
          this.$message.warning(`最多可上傳 ${this.maxCount} 個附件！`)
          break
        }
        const item = { name: f.name, path: '', url: '', file: f, status: 'uploading' }
        this.fileList.push(item)
        await this.doUpload(item)
      }
      this.emitValue()
    },
    async doUpload (item) {
      try {
        const res = await uploadSignFile(item.file)
        if (res.code === 200 && res.data && res.data.path) {
          item.path = res.data.path
          item.url = res.data.url || ''
          item.status = 'done'
        } else {
          item.status = 'error'
          item.errorMsg = res.message || '上傳失敗'
        }
      } catch (e) {
        item.status = 'error'
        item.errorMsg = e.message || '上傳失敗'
      }
      this.emitValue()
    },
    async retryUpload (idx) {
      const item = this.fileList[idx]
      if (!item || !item.file) return
      item.status = 'uploading'
      await this.doUpload(item)
    },
    removeFile (idx) {
      this.fileList.splice(idx, 1)
      this.emitValue()
    },
    emitValue () {
      this.$emit('input', this.fileList.filter(f => f.status === 'done').map(f => f.path))
    },
    hasUploading () { return this.fileList.some(f => f.status === 'uploading') },
    hasError () { return this.fileList.some(f => f.status === 'error') },
    reset () { this.fileList = [] }
  }
}
</script>

<style scoped>
.dyn-filelist-btn {
  display: inline-block;
  padding: 6px 14px;
  border: 1px dashed #188AFF;
  border-radius: 4px;
  color: #188AFF;
  background: #f7fbff;
  cursor: pointer;
  font-size: 16px;
}
.dyn-filelist-count { color: #999; font-size: 14px; margin-left: 4px; }
.dyn-filelist-preview { list-style: none; padding: 0; margin: 8px 0 0; }
.dyn-filelist-preview li {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border: 1px solid #eee;
  border-radius: 4px;
  margin-bottom: 4px;
  font-size: 15px;
}
.dyn-filelist-name { flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right: 8px; }
.dyn-filelist-status { font-size: 14px; flex-shrink: 0; }
.dyn-filelist-status.uploading { color: #E6A23C; }
.dyn-filelist-status.done { color: #67C23A; }
.dyn-filelist-status.error { color: #f56c6c; }
.dyn-filelist-retry { color: #188AFF; cursor: pointer; margin-left: 8px; font-size: 14px; flex-shrink: 0; }
.dyn-filelist-remove { color: #f56c6c; cursor: pointer; margin-left: 8px; font-size: 14px; flex-shrink: 0; }
@media screen and (max-width: 768px) {
  .dyn-filelist-btn { display: block; width: 100%; text-align: center; padding: 10px 0; }
  .dyn-filelist-preview li { flex-wrap: wrap; padding: 10px 12px; }
  .dyn-filelist-name { width: 100%; padding-right: 0; white-space: normal; }
  .dyn-filelist-status { flex-shrink: 0; }
}
</style>
